// Code generated by scripts/gen-historical-workflow.py; DO NOT EDIT.
export const archiveSections = [
  {
    "key": "actions_history",
    "source": "actions",
    "title": "HistoricalAction",
    "fields": [
      {
        "key": "id",
        "meaning": "Original source id; inert evidence only, never native authority or execution."
      },
      {
        "key": "company_id",
        "meaning": "Original source company_id; inert evidence only, never native authority or execution."
      },
      {
        "key": "site_id",
        "meaning": "Original source site_id; inert evidence only, never native authority or execution."
      },
      {
        "key": "source_comment_id",
        "meaning": "Original source source_comment_id; inert evidence only, never native authority or execution."
      },
      {
        "key": "body",
        "meaning": "Original source body; inert evidence only, never native authority or execution."
      },
      {
        "key": "source_label",
        "meaning": "Original source source_label; inert evidence only, never native authority or execution."
      },
      {
        "key": "origin",
        "meaning": "Original source origin; inert evidence only, never native authority or execution."
      },
      {
        "key": "due_date",
        "meaning": "Original source due_date; inert evidence only, never native authority or execution."
      },
      {
        "key": "assigned_to",
        "meaning": "Original source assigned_to; inert evidence only, never native authority or execution."
      },
      {
        "key": "status",
        "meaning": "Original source status; inert evidence only, never native authority or execution."
      },
      {
        "key": "created_at",
        "meaning": "Original source created_at; inert evidence only, never native authority or execution."
      },
      {
        "key": "updated_at",
        "meaning": "Original source updated_at; inert evidence only, never native authority or execution."
      },
      {
        "key": "created_by",
        "meaning": "Original source created_by; inert evidence only, never native authority or execution."
      },
      {
        "key": "done_at",
        "meaning": "Original source done_at; inert evidence only, never native authority or execution."
      },
      {
        "key": "done_by",
        "meaning": "Original source done_by; inert evidence only, never native authority or execution."
      }
    ]
  },
  {
    "key": "board_commands_history",
    "source": "board_commands",
    "title": "HistoricalBoardCommand",
    "fields": [
      {
        "key": "id",
        "meaning": "Original source id; inert evidence only, never native authority or execution."
      },
      {
        "key": "actor",
        "meaning": "Original source actor; inert evidence only, never native authority or execution."
      },
      {
        "key": "input",
        "meaning": "Original source input; inert evidence only, never native authority or execution."
      },
      {
        "key": "kind",
        "meaning": "Original source kind; inert evidence only, never native authority or execution."
      },
      {
        "key": "understood",
        "meaning": "Original source understood; inert evidence only, never native authority or execution."
      },
      {
        "key": "proposal",
        "meaning": "Original source proposal; inert evidence only, never native authority or execution."
      },
      {
        "key": "selection",
        "meaning": "Original source selection; inert evidence only, never native authority or execution."
      },
      {
        "key": "applied",
        "meaning": "Original source applied; inert evidence only, never native authority or execution."
      },
      {
        "key": "blocked",
        "meaning": "Original source blocked; inert evidence only, never native authority or execution."
      },
      {
        "key": "applied_at",
        "meaning": "Original source applied_at; inert evidence only, never native authority or execution."
      },
      {
        "key": "undone_at",
        "meaning": "Original source undone_at; inert evidence only, never native authority or execution."
      },
      {
        "key": "created_at",
        "meaning": "Original source created_at; inert evidence only, never native authority or execution."
      },
      {
        "key": "undone_by",
        "meaning": "Original source undone_by; inert evidence only, never native authority or execution."
      }
    ]
  }
] as const;
